<template>
    <el-dialog title="完善信息" width="600px" top="80px" :visible.sync="show" @open="handleOpen" :close-on-click-modal="false">
        <el-form :model="form" label-width="100px" size="medium">
            <el-form-item label="出生地">
                <el-input v-model="form.csd" placeholder="您的出生地"></el-input>
            </el-form-item>
            <el-form-item label="联系人">
                <el-input v-model="form.lxr" placeholder="联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话">
                <el-input v-model="form.lxrdh" placeholder="联系人电话"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="show = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submit()">保 存</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/ecmascript-6">
    import {saveEmpiUserInfo} from '@/api/empiApi.js'

    export default{
        name:'',
        data(){
            return {
                show:false,
                form:{
                    csd:'',
                    lxr:'',
                    lxrdh:''
                },
                mdmId:''
            }
        },
        methods:{
            showDialog(action){
                this.show = action;
            },
            handleOpen(){
                setTimeout(() => {
                    let info = this.$cookies.get('LOGIN_INFO')
                    this.form = {
                        csd:info && info.csd ? info.csd : '',
                        lxr:info && info.lxr ? info.lxr : '',
                        lxrdh:info && info.lxrdh ? info.lxrdh : '',
                    }
                    this.mdmId = info && info.mdmId ? info.mdmId : ''
                },0)
            },
            submit(){
                let props = {
                    CSD:this.form.csd,
                    LXRDH:this.form.lxrdh,
                    LXRXM:this.form.lxr
                }
                if(this.mdmId){
                    saveEmpiUserInfo({
                        mdmId:this.mdmId ? this.mdmId : '',
                        prop:JSON.stringify(props)
                    }).then(res=>{

                    }).catch(err=>{

                    })
                }
            }
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/pc/components/edit.vue